export default {"src":"/_next/static/media/details.167b93e8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};